import React from 'react';
import { useReveal } from '../lib/useReveal';
const MODULES = [{
  title: 'Fundamentos y activación energética',
  desc: 'Comprende cómo funciona la energía y activa tu proceso correctamente.'
}, {
  title: 'Sistema de chakras',
  desc: 'Aprende a identificar bloqueos y comprender tu estado emocional.'
}, {
  title: 'Autosanación guiada',
  desc: 'Práctica paso a paso para comenzar tu transformación.'
}, {
  title: 'Nivel II – Símbolos',
  desc: 'Aprende a dirigir la energía con intención y precisión.'
}, {
  title: 'Sanación a distancia',
  desc: 'Amplía tu capacidad de aplicación profesional.'
}, {
  title: 'Nivel III – Maestría',
  desc: 'Integra el método completo y consolida tu formación.'
}];
export function HowItWorksSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="modules" className="bg-[#0f0f1a] text-white py-14 md:py-20 px-4 relative overflow-hidden border-t border-white/5" data-id="element-213">
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-214"></div>

      <div className="container mx-auto max-w-5xl relative z-10" data-id="element-215">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-216">
          <span className="text-[#f0c040] text-sm font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-217">
            📚 Estructura del Curso
          </span>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4 leading-tight text-white" data-id="element-218">
            FORMACIÓN COMPLETA DE REIKI
          </h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto leading-relaxed" data-id="element-219">
            Aprendé Reiki paso a paso
            <br data-id="element-220" />
            con un sistema estructurado en 6 tomos
          </p>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10 ${vis2 ? 'is-visible' : ''}`} data-id="element-221">
          {MODULES.map((mod, idx) => <div key={idx} className="bg-[#252538] border border-white/10 rounded-2xl p-6 hover:bg-[#2a2a40] hover:border-[#d4a017]/30 transition-colors group relative overflow-hidden shadow-sm" style={{
          transitionDelay: `${idx * 100}ms`
        }} data-id="element-222">
              <div className="absolute -right-4 -top-4 text-8xl font-serif font-bold text-white/5 group-hover:text-[#d4a017]/10 transition-colors select-none pointer-events-none" data-id="element-223">
                {idx + 1}
              </div>

              <div className="relative z-10" data-id="element-224">
                <span className="inline-flex items-center gap-2 text-[#f0c040] font-bold text-sm tracking-widest uppercase mb-3" data-id="element-225">
                  🟢 Módulo {idx + 1}
                </span>
                <h3 className="text-xl font-serif font-bold text-white leading-snug mb-3" data-id="element-226">
                  {mod.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-227">
                  {mod.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center border-t border-white/10 pt-6" data-id="element-228">
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-229">
            Todo progresivo. Todo claro. Todo estructurado.
          </p>
        </div>
      </div>
    </section>;
}